import { SimpleSubscription } from "~/modules/reporter/CustomObservable/SimpleSubscription";
import { SimpleObserver } from "~/modules/reporter/CustomObservable/SimpleObserver";

export class SimpleObservableImpl<T> {
    constructor(private readonly observe?: (observer: SimpleObserver<T>) => (() => void) | void) {}

    subscribe(observer: SimpleObserver<T>): SimpleSubscription {
        const teardown = this.observe ? this.observe(observer) : undefined;
        return {
            unsubscribe: () => {
                if (teardown) teardown();
            }
        };
    }
}
